import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import LegionCommandCenter from './pages/LegionCommandCenter';
import NationalDealSearch from './pages/NationalDealSearch';
import CRM from './pages/CRM';
import DealPipeline from './pages/DealPipeline';
import LegionBots from './pages/LegionBots';
import PropertyDetail from './pages/PropertyDetail';
import UnderwritingCalculator from './pages/UnderwritingCalculator';
import ContractGenerator from './pages/ContractGenerator';
import Portfolio from './pages/Portfolio';
import PropertyProfile from './pages/PropertyProfile';
import Accounting from './pages/Accounting';
import VoiceAI from './pages/VoiceAI';
import VoiceAgentConfig from './pages/VoiceAgentConfig';
import SplashPage from './pages/SplashPage';
import LegionValuation from './pages/LegionValuation';
import AdminSettings from './pages/AdminSettings';
import NotificationCenter from './pages/NotificationCenter';
import Layout from './components/Layout';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
      <Routes>
        <Route path="/splash" element={<SplashPage />} />
        <Route path="/landing" element={<SplashPage />} />
        <Route path="/login" element={<Login />} />
        
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<LegionCommandCenter />} />
          <Route path="search" element={<NationalDealSearch />} />
          <Route path="comps" element={<LegionValuation />} />
          <Route path="property/:id" element={<PropertyDetail />} />
          <Route path="underwriting" element={<UnderwritingCalculator />} />
          <Route path="crm" element={<CRM />} />
          <Route path="legion" element={<LegionBots />} />
          <Route path="deals" element={<DealPipeline />} />
          <Route path="deals/:type" element={<DealPipeline />} />
          <Route path="contracts" element={<ContractGenerator />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="portfolio/:id" element={<PropertyProfile />} />
          <Route path="accounting" element={<Accounting />} />
          <Route path="notifications" element={<NotificationCenter />} />
          <Route path="admin" element={<AdminSettings />} />
          <Route path="voice-ai" element={<VoiceAI />} />
          <Route path="voice-ai/config" element={<VoiceAgentConfig />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
